export const lightcolors = {
    theme: "light",
    primary: "#656AD3",
    secondary: "#4ecdc4",
    bodyText: "#1B1C21",
    antibodyText: "#ffffff",
    black: "#000",
    white: "#fff",
    medium: "#6e6969",
    light: "#f8f4f4",
    dark: "#0c0c0c",
    danger: "#ff5252",
    background: "#ffffff",
    headerBackground: "#b9bcf8",
    abyss: "#6E717B",
    tagBackground: "#E8E9EA",
    tagText: "#34383E",
    placeholderTextColor: "#6E717B", 
    textInputColor: "#ffffff",
    textInputBorderColor: "#E8E9EA",
    hyperlinkText:  "#656AD3",
    listItemBackground: "#FFFFFF", 
    listItemSpecialBackground: "#F6F6FF",
    error: "#a55450",
    weakPassword: "#f55d5d",
    goodPassword: "#34383e",
    strongPassword: "#34383e",
    darkestAbyss: "#1B1C21",
    lightAbyss: "#C7CBD0",
    navigationBackground: "#272A2F",
    cardBackground: "#272A2F",
    selectedText: "#FFFFFF",
    lightSunrise: "#FFE09C",
    disabledBackground: "#C7CBD0",
    lightNebula: "#B9BCF8",
    lightestNebula: "#EBEBFF",
    darkPurple: "#656AD3",
    obNext: "#34383E",
    darkCloud: "#C7CBD0",
  };
  
  export const colors = (theme) => {
    return lightcolors;
  }
  
  